import { Grow, IconButton, InputAdornment, Tooltip } from '@mui/material';
import { DateField, DateFieldProps } from '@mui/x-date-pickers';
import {
  Controller,
  Path,
  UseControllerProps,
  UseFormReturn,
} from 'react-hook-form';
import { Icon } from '../../icon/icon';

interface PropTypes<T> extends DateFieldProps<Date> {
  name: Path<T>;
  form: UseFormReturn<any>;
  defaultValue: UseControllerProps['defaultValue'];
  rules?: UseControllerProps['rules'];
  isReferral?: boolean;
}

export const ControlledDateField = <T extends unknown>({
  name,
  form: { control, resetField },
  defaultValue,
  isReferral,
  rules,
  ...props
}: PropTypes<T>) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field: { value, ref, ...field }, fieldState }) => (
      <DateField
        {...field}
        value={value ? new Date(value) : null}
        inputRef={ref}
        format="MM/dd/yyyy"
        formatDensity="spacious"
        slotProps={{
          textField: {
            error: !!fieldState.error,
            helperText: fieldState.error?.message,
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <Grow in={!!value}>
                    <Tooltip title="Clear date">
                      <IconButton
                        aria-label="Clear date"
                        disabled={isReferral}
                        edge="end"
                        onClick={() => resetField(name)}
                      >
                        <Icon icon="Xmark" />
                      </IconButton>
                    </Tooltip>
                  </Grow>
                </InputAdornment>
              ),
            },
          },
        }}
        fullWidth
        {...props}
      />
    )}
  />
);
